<template>


  <div class="fixed-top" id="header">
    <b-navbar toggleable="lg" variant="" type="">
      <b-navbar-brand href="#">
        <router-link to="/">
          <div style="display:flex; align-items:center; gap:8px;">
            <img class="logo" src="../assets/apdcl_logo.png" alt="logo" />
            <div>
              <div id="title-a" class="title-a text-blue">অসম শক্তি বিতৰণ কোম্পানী লিমিটেড</div>
              <div id="title-e" class="title-e text-blue">Assam Power Distribution Company Limited</div>
            </div>
          </div>
        </router-link>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse" style="border:none; outline:none;">
        <template>
          <div style="border:solid 1px black; border-radius:3px; font-size:2rem;">
            <b-icon icon="list"></b-icon>
          </div>
        </template>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav class="nav-bgcolor responsiveNavbar" style="box-shadow: 2px 2px 9px 0px;">


        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-row>
            <b-col cols="3" offset=1 class=""><b-nav-item href="#"><router-link class="r-link iphone5font"
                  to="/">Home</router-link></b-nav-item></b-col>
            <b-col cols="4"><b-nav-item href="#"><router-link class="r-link iphone5font" to="/ActsAndRules">Acts &
                  Policies</router-link></b-nav-item></b-col>
            <b-col cols="4"><b-nav-item href="#"><router-link class="r-link iphone5font"
                  to="/AllDocuments">Documents</router-link></b-nav-item></b-col>
          </b-row>
          <b-row>
            <b-col cols="3" offset=1>
              <b-nav-item-dropdown class="r-link iphone5font" text="Tender" style="width:15rem !important; z-index:1;"
                right>
                <b-dropdown-item href="TenderCurrent"><span class="iphone5font dropdownItem">Current Financial
                    Year</span></b-dropdown-item>
                <b-dropdown-item href="TenderPrevious"><span class="iphone5font dropdownItem">Previous Financial
                    Year</span></b-dropdown-item>
                <b-dropdown-item href="TenderArchive"><span
                    class="iphone5font dropdownItem">Archive</span></b-dropdown-item>
                <!-- <b-dropdown-item href="#"><router-link to="/TenderPrevious">Previous Financial Year</router-link></b-dropdown-item> -->
                <!-- <b-dropdown-item href="#"><router-link to="/TenderArchive">Financial Year 2018-2019</router-link></b-dropdown-item> -->
              </b-nav-item-dropdown>
            </b-col>

            <b-col cols="4">
              <b-nav-item-dropdown class="r-link iphone5font" text="News & Media"
                style="width:15rem !important; z-index:1;" right>
                <b-dropdown-item href="Award"><span class="dropdownItem iphone5font">Awards and
                    Recognition</span></b-dropdown-item>
                <b-dropdown-item href="Newsletter"><span
                    class="dropdownItem iphone5font">Newsletter</span></b-dropdown-item>
                <b-dropdown-item href="BijuleeNewsBulletin"><span class="dropdownItem iphone5font">Bijulee News
                    Bulletin</span></b-dropdown-item>
                <b-dropdown-item href="PressRelease"><span class="dropdownItem iphone5font">Press
                    Release</span></b-dropdown-item>
                <b-dropdown-item href="https://www.youtube.com/watch?v=tgSJKMbjFIc&feature=youtu.be"
                  target="_blank"><span class="dropdownItem iphone5font">Talk Show about APDCL</span></b-dropdown-item>
                <b-dropdown-item href="Testimonial"><span
                    class="dropdownItem iphone5font">Testimonials</span></b-dropdown-item>
                <b-dropdown-item href="Workshop"><span class="dropdownItem">Workshop & Seminar</span></b-dropdown-item>
              </b-nav-item-dropdown>
            </b-col>

            <!-- <b-nav-item-dropdown class="r-link" text="Newsroom" right>
              <b-dropdown-item class="dropdownItem" href="Newsletter"><span class="dropdownItem" >Newsletter</span></b-dropdown-item>
              <b-dropdown-item href="BijuleeNewsBulletin"><span class="dropdownItem" >Bijulee News Bulletin</span></b-dropdown-item>
              <b-dropdown-item href="PressRelease"><span class="dropdownItem" >Press Release</span></b-dropdown-item>
              <b-dropdown-item href="https://www.youtube.com/watch?v=tgSJKMbjFIc&feature=youtu.be" target="_blank"><span class="dropdownItem" >Talk Show about APDCL</span></b-dropdown-item>
              <b-dropdown-item href="Testimonial"><span class="dropdownItem" >Testimonials</span></b-dropdown-item>
            </b-nav-item-dropdown> -->

            <b-col cols="4" style="z-index:1;"><b-nav-item href="#"><router-link class="r-link iphone5font"
                  to="/Contact">Contact</router-link></b-nav-item></b-col>
          </b-row>
          <b-row>
            <b-col cols="3" offset=1><b-nav-item href="#"><router-link class="r-link iphone5font" to="/About">About
                  Us</router-link></b-nav-item></b-col>
            <b-col cols="4"><b-nav-item href="#"><router-link class="r-link iphone5font"
                  to="/Gallery">Gallery</router-link></b-nav-item></b-col>
            <b-col cols="4"><b-nav-item href="#"><router-link class="r-link iphone5font"
                  to="/RTI">RTI</router-link></b-nav-item></b-col>
          </b-row>
          <b-row>
            <b-col cols="3" offset=1><b-nav-item href="#"><router-link class="r-link iphone5font"
                  to="/Career">Career</router-link></b-nav-item></b-col>
            <b-col cols="4"><b-nav-item href="#"><router-link class="r-link iphone5font"
                  to="/FAQ">FAQ</router-link></b-nav-item></b-col>
            <b-col cols="4">
              <b-nav-item>
                <div id="login">
                  <b-button v-b-modal.modal-headerMobile size="sm" class="iphone5font" variant="outline-danger"
                    style="margin-top: -5px;">
                    Log In
                  </b-button>
                </div>
              </b-nav-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3" offset=1><b-nav-item href="#">
                <router-link class="r-link iphone5font customSpan" to="/AssameseMobile">অসমীয়া</router-link>
                <!-- <router-link class="r-link iphone5font customSpan" to="/">অসমীয়া</router-link> -->
              </b-nav-item></b-col>
          </b-row>

        </b-navbar-nav>
      </b-collapse>

    </b-navbar>
    <b-modal no-close-on-esc no-close-on-backdrop class="modal fade" id="modal-headerMobile" hide-footer
      title="Log In to Your Account">
      <div>
        <b-overlay :show="show" spinner-variant="primary" spinner-large rounded="sm"
          style="z-index:10000;position:absolute" variant="dark" id="loader">


          <br>
          <!-- USER LOGIN-->
          <div id="userDiv" class="showDiv">

            <label>Enter Mobile Number </label>
            <b-input-group class="mb-2" style="width:100%;padding-top:0px;padding-bottom:10px;">
              <b-input-group-prepend is-text>
                <b-icon icon="phone"></b-icon>
              </b-input-group-prepend>
              <b-form-input type="text" id="mobileNoMb" autocomplete="off" placeholder="Mobile Number" :readonly="mobileReadonly"></b-form-input>
            </b-input-group>
            <span style="display:none;color:red;text-align: center;" id="errorMsg" v-show="loginErrorMsg">{{ loginErrorMsg }}</span>
            <div id="sendOtpBtn" v-show="!otpSent && !otpSentFL && !alreadyLoggedIn">
              <b-row>
                <b-col cols="12" offset="">
                  <router-link to="">
                    <b-button block @click="sendOtp()" variant="primary">Log In</b-button>
                  </router-link>
                </b-col>
              </b-row>
            </div>
            <div id="alreadyLoggedInDiv" style="padding-top:7px; display:none" v-show="alreadyLoggedIn && !otpSentFL">
              <b-row>
                <b-col cols="12" style="color:red;text-align: center;">
                  User is already logged in a different PC.
                  Click on Force Logout to terminate the active session.
                </b-col>
              </b-row>
              <br>
              <b-row>
                <b-col cols="12">
                  <b-button block @click="sendOtpFL()" variant="danger">Force Logout</b-button>
                </b-col>
              </b-row>
            </div>
            <div id="otpDiv" style="display:none" v-show="otpSent">
              <label>Enter OTP </label>
              <b-input-group class="mb-2" style="width:100%;">

                <b-input-group-prepend is-text>
                  <b-icon icon="check2-circle"></b-icon>
                </b-input-group-prepend>
                <b-form-input type="text" id="otp" autocomplete="off" placeholder="Enter OTP" required></b-form-input>
              </b-input-group>
              <span style="color:red;padding-left:40%" id="otpInvalid"> </span>
              <b-row>
                <b-col cols="12" offset="">

                  <b-button block @click="loginUser()" variant="primary">Verify OTP & Log In</b-button>
                  <b-button block @click="resendOtp()" variant="outline-primary">Resend OTP</b-button>
                </b-col>
              </b-row>
            </div>
            <div id="otpDivFL" style="display:none" v-show="otpSentFL">
              <label>Enter OTP </label>
              <b-input-group class="mb-2" style="width:100%;">
                <b-input-group-prepend is-text>
                  <b-icon icon="check2-circle"></b-icon>
                </b-input-group-prepend>
                <b-form-input type="text" id="otpNoFL" autocomplete="off" placeholder="Enter OTP"
                  required></b-form-input>
              </b-input-group>
              <span style="color:red;padding-left:40%" id="otpInvalidFL"> </span>
              <b-row>
                <b-col cols="12" offset="">
                  <b-button block variant="danger" @click="forceLogout()">Verify OTP & Force Logout </b-button>
                </b-col>
              </b-row>
            </div>
            <b-row>
              <b-col cols="12" style="text-align:center">
                <span>Don't have an Account? <br>
                  <router-link to="/ConsumerRegistration">Register Now</router-link>
                </span>
              </b-col>
            </b-row>
          </div>

          <br>
        </b-overlay>
      </div>
    </b-modal>



  </div>

</template>


<script scoped="true">

import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

var user = 0;

export default {
  computed: {
    userIdState() {
      return this.user_id.length == 12 ? true : false
      //this.login()
    }
  },
  data() {
    return {
      selected: 'consumer',
      user_id: '',
      show: false,
      mobileNo: "",
      urlCommon: this.$urlCommon + "/api/postOtp",
      otpSent: false,
      otpSentFL: false,
      alreadyLoggedIn: false,
      loginErrorMsg: '',
      mobileReadonly: false
    }
  },

  methods: {
    scrollFunction(event) {
      if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        document.getElementById("header").style.backgroundColor = "#eeeeee";

      } else {
        document.getElementById("header").style.backgroundColor = "";

      }
    },

    sendOtp() {
      var mobile = document.getElementById("mobileNoMb").value;
      if ((mobile.length != 10)) {
        this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return;
      }
      var parent = this;


      let data = JSON.stringify({
        "mobileNo": mobile,
        "type": "new",
        "src": "portal"
      });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee + '/auth/login',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      // alert(JSON.stringify(config))
      // return;

      this.show = true;
      axios.request(config)
        .then((response) => {

          parent.show = false;
          if (response.data.status == "success") {
            parent.$bvToast.toast('OTP Sent Successfully !', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
            parent.mobileReadonly = true;
            parent.otpSent = true;
            parent.loginErrorMsg = '';
          }
          else if (response.data.status == "error" && response.data.message == "already logged in") {
            console.log("exist");
            parent.mobileReadonly = true;
            parent.alreadyLoggedIn = true;
            parent.loginErrorMsg = '';

          }
          else if (response.data.status == "error") {

            parent.loginErrorMsg = response.data.message;

          }
        })
        .catch((error) => {
          console.log(error);
        });

    },
    loginUser() {
      var mobile = document.getElementById("mobileNoMb").value;
      var otpNo = document.getElementById("otp").value;

      if ((mobile.length != 10)) {
        this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return;
      }
      var parent = this;


      let data = JSON.stringify({
        "mobileNo": mobile,
        "otpNo": otpNo,
        "src": "portal"
      });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee + '/auth/otp/verify',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      this.show = true;
      axios.request(config)
        .then((response) => {
          console.log(response.data);
          parent.show = false;
          if (response.data.status == "success") {

            var accessToken = response.data.accessToken;
            sessionStorage.setItem("accessToken", response.data.accessToken);
            sessionStorage.setItem("consList", JSON.stringify(response.data.consList));
            sessionStorage.setItem("mobile", mobile);
            console.log(response.data.consList[0]);

            var consNo = response.data.consList[0];
            sessionStorage.setItem("selectedCons", consNo);

            // window.location.href = "/website/ConsumerDashboard";
            // return false;
            // return;
            var consType;

            let data1 = JSON.stringify({
              "consNo": consNo,
              "mobileNo": mobile
            });

            let config1 = {
              method: 'post',
              maxBodyLength: Infinity,
              url: this.$urlCommon + '/api/web/auth/getConsDetails',
              headers: {
                'Authorization': accessToken,
                'Content-Type': 'application/json'
              },
              data: data1
            };

            axios.request(config1)
              .then((response) => {
                parent.show = false;
                console.log(response.data);
                if (response.data.message == "00") {
                  sessionStorage.setItem("selectedCons", consNo);
                  consType = response.data.connType;
                  if (consType == "POSTPAID") {
                    window.location.href = "/website/ConsumerDashboardPostpaid";
                    return false;

                  }
                  else if (consType == "SMART POSTPAID") {
                    window.location.href = "/website/ConsumerDashboardSmartPostpaid";
                    return false;
                  }
                  else if (consType == "PREPAID") {
                    window.location.href = "/website/ConsumerDashboardPrepaid";
                    return false;

                  }
                  else if (consType == "SMART PREPAID") {
                    window.location.href = "/website/ConsumerDashboardSmartPrepaid";
                    return false;

                  }
                }
                else {
                  parent.$bvModal.show('model');
                  document.getElementById("modalMsg").innerHTML = "Consumer Not Found";
                }
              })
              .catch((e) => {
                parent.show = false;
                console.log("Caught :::::::::::::::", e.message);
                if (e.message == "Network Error") {
                  parent.$bvModal.show('redirectModal');
                  document.getElementById("redirectModalMsg").innerHTML = "Session Expired, Please log in again";
                }
              });
          }
          else {
            parent.$bvToast.toast('OTP Invalid !', {
              title: `Failure`,
              variant: 'danger',
              solid: true
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });

    },


    resendOtp() {
      var parent = this;
      var mobile = document.getElementById("mobileNoMb").value;



      let data = JSON.stringify({
        "mobileNo": mobile,
        "type": "old",
        "src": "portal"

      });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee + '/auth/login',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      parent.show = true;
      axios.request(config)
        .then((response) => {

          parent.show = false;
          if (response.data.status == "success") {
            parent.$bvToast.toast('OTP Sent Successfully !', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
          }
          else {
            parent.$bvToast.toast('OTP Could not Sent !', {
              title: `Error`,
              variant: 'danger',
              solid: true
            });
          }
        })
        .catch((error) => {
          console.log(error);
          parent.show = false;
          parent.$bvToast.toast('Network Error !', {
            title: `Error`,
            variant: 'danger',
            solid: true
          });
        });
    },
    sendOtpFL() {
      var mobile = document.getElementById("mobileNoMb").value;

      if ((mobile.length != 10)) {
        this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
          title: `Error`,
          variant: 'danger',
          solid: true
        })
        return;
      }
      var parent = this;
      this.show = true;

      let data = JSON.stringify({
        "mobileNo": mobile,
        "type": "new",
        "src": "portal-fl"
      });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee + '/auth/login',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };


      axios.request(config)
        .then((response) => {
          // console.log(response.data);
          parent.show = false;
          if (response.data.status == "success") {
            parent.$bvToast.toast('OTP Sent Successfully !', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
            parent.mobileReadonly = true;
            parent.otpSentFL = true;
            parent.alreadyLoggedIn = false;
          }

        })
        .catch((error) => {
          console.log(error);
        });

    },
    forceLogout() {
      var parent = this;
      var mobile = document.getElementById("mobileNoMb").value;
      var otpNo = document.getElementById("otpNoFL").value;

      let data = JSON.stringify({
        "mobileNo": mobile,
        "otpNo": otpNo,
      });

      let config = {
        method: 'post',
        url: this.$urlMyBijulee + '/auth/forceLogout',
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      parent.show = true;
      axios.request(config)
        .then((response) => {

          parent.show = false;
          if (response.data.status == "success") {
            parent.$bvToast.toast('Force Log Out Successfull. Please Log In now', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
            parent.otpSentFL = false;
            parent.otpSent = false;
            parent.alreadyLoggedIn = false;
          }
          else {
            parent.$bvToast.toast('Invalid OTP!', {
              title: `Error`,
              variant: 'danger',
              solid: true
            });
          }
        })
        .catch((error) => {
          console.log(error);
          parent.show = false;
          parent.$bvToast.toast('Network Error !', {
            title: `Error`,
            variant: 'danger',
            solid: true
          });
        });
    },

  },
  mounted() {
    //   var url_string = window.location.href;
    //   var url = new URL(url_string);
    //   var mobile = url.searchParams.get("mobileNo");
    //   console.log("mobile:::::"+mobile)
    //   if(mobile>0)
    //   {
    //     this.$bvModal.show("modal-loginMb");
    //     this.mobileNo=mobile;
    //     }
  }
}

</script>

<style lang="scss" scoped="true">
.customSpan {
  background-color: #fff78d;
  padding: 4px 10px 4px 10px;
  font-weight: 500;
  border-radius: 2px;
}

#header {
  transition: 0.6s;
  /*height: 10vh;*/
}

.marginLeft {
  margin-left: 30px;
}

.title-a {
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.5px;
}

.title-e {
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.tagline-a,
.tagline-e,
.language,
.support {
  display: none !important;
}

:deep(.navbar) {
  flex-wrap: nowrap !important;
}

:deep(.navbar-collapse) {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 999;
}

.navbar-brand {
  margin-left: -10px !important;
  padding: 0 !important;
}

.tagline-a {
  font-size: 0.9rem;
  font-style: italic;

}

.tagline-e {
  font-size: 0.9rem;
  font-style: italic;

}

.responsiveNavbar {}

table {
  color: #e4dbdb;
  table-layout: fixed;
  /* ← add this */
  width: auto;
  /* ← add this */
}

td {
  text-align: left !important;
  white-space: nowrap;
  /* ← prevents text from collapsing the td */
}

.text-orange {
  color: #ff5722
}

.text-blue {
  color: #01579b;
}

.border {
  border: 1px solid;
}

.support {
  font-size: 0.8rem;
  float: right;
  margin-top: -110px !important;
  margin-right: 170px;
  text-shadow: 0px 0px 1px #0000005c;
}

.language {
  float: right;
  margin-top: -115px !important;
  margin-right: 25px;
}

#header,
#title-e,
#title-a,
#tagline-a,
#tagline-e,
#support,
#language {
  transition: 0.5s;
}

.form-popup {
  display: none;
  position: fixed;
  bottom: 0;
  right: 15px;
  border: 3px solid #f1f1f1;
  z-index: 9;
}

.logo {
  height: 45px;
  width: 45px;
  min-width: 45px;
  object-fit: contain;
  flex-shrink: 0;
}

.nav-bgcolor {
  background-color: white;
}

.hideDiv {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s linear;

  padding: 0rem;
}

.showDiv {
  visibility: visible;
  opacity: 1;
}

@media only screen and (min-device-width: 320px) and (max-device-height: 568px) and (orientation : portrait) and (-webkit-device-pixel-ratio: 2) {

  .title-a {
    // font-size: 1.3rem;
    font-size: 10px;
    font-weight: 900;
    margin-top: 0px;
  }

  .title-e {
    // font-size: 1.3rem;
    font-size: 10px;
    font-weight: 700;

  }

  .navbar-toggler {
    padding: 0px !important;
  }

  .navbar-brand {
    margin-right: 0px !important;
  }

  .iphone5font {
    font-size: 12px;
  }

  .logo {
    height: 28px;
    width: 28px;
    object-fit: contain;
    flex-shrink: 0;
  }
}

@media only screen and (max-width: 480px) {
  .title-a {
    font-size: 13px;
    font-weight: 900;
    letter-spacing: 0px;
    white-space: normal;      /* ← allow wrapping */
    overflow: visible;
    text-overflow: unset;
    max-width: unset;
    line-height: 1.2;
  }

  .title-e {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0px;
    white-space: normal;      /* ← allow wrapping */
    overflow: visible;
    text-overflow: unset;
    max-width: unset;
    line-height: 1.2;
  }

  .logo {
    height: 38px;
    width: 38px;
    min-width: 38px;
  }

  .navbar-brand {
    max-width: calc(100% - 55px) !important;
    flex-shrink: 1;
    overflow: hidden;
  }
}

@media only screen and (min-device-width: 375px) and (max-device-height: 667px) and (orientation : portrait) and (-webkit-device-pixel-ratio: 2) {
  .title-a {
    // font-size: 1.3rem;
    font-size: 12px;
    font-weight: 900;
    margin-top: 0px;
  }

  .title-e {
    // font-size: 1.3rem;
    font-size: 12px;
    font-weight: 700;

  }

  .navbar-toggler {
    padding: 0px !important;
  }

  .navbar-brand {
    margin-right: 10px !important;
  }
}

@font-face {
  font-family: Assamese_Font;
  src: url("../assets/Assamese_font/KirtanUni.ttf");
}

div {
  font-family: arial, Assamese_Font;
}
</style>